import { render, staticRenderFns } from "./SideModal.vue?vue&type=template&id=c0c3c2be&scoped=true"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"
import style0 from "./SideModal.vue?vue&type=style&index=0&id=c0c3c2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c3c2be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('C:/app/components/Components/Loader.vue').default,Close: require('C:/app/components/Helpers/Close.vue').default})
